module.exports = __webpack_public_path__ + "static/media/AIMG_1525.1be93a5f.jpg";